/* eslint-disable react/no-unstable-nested-components */
import { Trans, useTranslation } from 'react-i18next';
import { memo, useCallback, useEffect, useRef, useState } from 'react';
import Carousel from 'react-multi-carousel';
import ScrollContainer from 'react-indiana-drag-scroll';
import styles from './OurExperiences.module.scss';
import plans from '../../../../database/plans';
import DestinationCard from '../../../globals/destinationCard/DestinationCard';
import 'react-multi-carousel/lib/styles.css';

interface IProps {
    from?: string;
}

const responsive = {
    desktop: {
        breakpoint: { max: 10000, min: 1300 },
        items: 4,
    },
    tablet: {
        breakpoint: { max: 1300, min: 800 },
        items: 3,
    },
    mobileWide: {
        breakpoint: { max: 800, min: 464 },
        items: 2,
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
    },
};

const activePlans = plans
    .filter((plan) => plan.active && [1, 3, 4, 7].includes(plan.id))
    .sort((a, b) => a.order - b.order);
/* const summerPlan = activePlans.find((plan) => plan.id === 4)!;
const otherPlans = activePlans.filter((plan) => plan.id !== 4)!;
const orderedPlans = [summerPlan, ...otherPlans]; */

const DiscoverDestinations = ({ from }: IProps) => {
    const mql = window.matchMedia('(min-width: 1300px)');
    const [isDesktop, setIsDesktop] = useState<boolean>(mql.matches);
    const carouselRef = useRef(null);
    const isLanding = from === 'landing';
    const { i18n } = useTranslation();

    const checkSize = (e: any) => {
        if (e.matches) {
            setIsDesktop(true);
        } else {
            setIsDesktop(false);
        }
    };

    useEffect(() => {
        mql.addEventListener('change', checkSize);

        return () => removeMediaListener();
    }, []);

    const removeMediaListener = useCallback(() => {
        mql.removeEventListener('change', checkSize);
    }, []);

    useEffect(() => {}, [i18n.language]);

    useEffect(() => {
        const carousel = carouselRef.current! as HTMLDivElement;
        if (!carousel) return;

        const visibleItems = carousel.querySelectorAll('li[aria-hidden="false"]');
        const hiddenItems = carousel.querySelectorAll('li[aria-hidden="true"]');

        visibleItems.forEach((item) => {
            const itemElement = item as HTMLElement;
            itemElement.tabIndex = 0;
        });

        hiddenItems.forEach((item) => {
            const itemElement = item as HTMLElement;
            itemElement.tabIndex = -1;
        });
    }, []);

    const HomePageTitle = memo(() => (
        <h2 className={`${styles.sectionTitle} ${styles.sectionTitleHome}`}>
            <Trans i18nKey="ourSurpriseTrips">
                Our
                <span className={styles.colouredTitle}>surprise trips</span>
            </Trans>
        </h2>
    ));

    const LandingPageTitle = memo(() => (
        <h2 className={styles.sectionTitle}>
            <Trans i18nKey="ourSurprisePackages">
                Our
                <span className={styles.colouredTitle}>Surprise</span>
                packages
            </Trans>
        </h2>
    ));

    return (
        <section className={styles.destinationContainer}>
            {!isLanding && <div className={styles.greyBox} />}
            {isLanding && <div className={styles.planeBackground} />}
            {isLanding ? <LandingPageTitle /> : <HomePageTitle />}
            {isDesktop ? (
                <div className={styles.carouselWrapper} ref={carouselRef}>
                    <Carousel
                        responsive={responsive}
                        infinite
                        shouldResetAutoplay={false}
                        autoPlay={false}
                        renderButtonGroupOutside
                        sliderClass={styles.sliderContainer}
                        containerClass={styles.carouselContainer}
                        itemClass={styles.carouselItem}
                        partialVisible={false}
                    >
                        {activePlans.map((planItem) => (
                            <DestinationCard
                                key={planItem.slug}
                                name={planItem.title}
                                summary={planItem.summary}
                                cardImage={planItem.card}
                                item={planItem.id}
                                mode="carousel"
                            />
                        ))}
                    </Carousel>
                </div>
            ) : (
                <ScrollContainer className={styles.indianaCarouselContainer}>
                    {activePlans.map((planItem) => (
                        <DestinationCard
                            key={planItem.slug}
                            name={planItem.title}
                            summary={planItem.summary}
                            cardImage={planItem.card}
                            item={planItem.id}
                            mode="carousel"
                        />
                    ))}
                </ScrollContainer>
            )}
        </section>
    );
};

export default DiscoverDestinations;
